module.exports = __webpack_public_path__ + "img/search.e2a0e3de.svg";